import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, Clock, Zap } from "lucide-react";
import { useI18n } from "@/i18n";
import { currencySymbol, PLACEHOLDER_IMG } from "@/lib/apiClient";

export const ActivityCard = ({ activity, index = 0 }) => {
  const { t } = useI18n();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.4) }}
    >
      <Link
        to={`/activities/${activity.id}`}
        data-testid={`activity-card-${activity.id}`}
        className="group block rounded-3xl bg-white overflow-hidden soft-shadow border border-black/5 hover:-translate-y-1 transition-transform duration-300"
      >
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={activity.images?.[0] || PLACEHOLDER_IMG}
            alt={activity.title}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          {activity.instant_booking && (
            <span className="absolute top-3 left-3 flex items-center gap-1 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-xs font-semibold text-primary">
              <Zap className="h-3 w-3" /> {t("instant")}
            </span>
          )}
          <div className="absolute bottom-3 right-3 rounded-full bg-black/60 backdrop-blur px-3 py-1 text-white text-sm font-semibold">
            {currencySymbol(activity.currency)}{activity.price}
          </div>
        </div>
        <div className="p-4">
          <div className="flex items-center justify-between gap-2 mb-1.5">
            <span className="text-xs font-bold uppercase tracking-wider text-accent">{activity.category?.replace("-", " ")}</span>
            <span className="flex items-center gap-1 text-sm font-semibold">
              <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
              {activity.rating} <span className="text-muted-foreground font-normal">({activity.review_count})</span>
            </span>
          </div>
          <h3 className="font-display font-semibold text-lg leading-tight line-clamp-2">{activity.title}</h3>
          <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{activity.short_description}</p>
          <div className="mt-3 flex items-center gap-1.5 text-sm text-muted-foreground">
            <Clock className="h-4 w-4" /> {activity.duration}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
